export function parseQueryString() {
    if (typeof window === 'undefined') return {}

    return new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => {
            const par = searchParams.get(prop)
            return par === '' ? true : par
        }
    })
}
